import { render, staticRenderFns } from "./AK6Icon.vue?vue&type=template&id=4fc4c1fa&scoped=true&"
import script from "./AK6Icon.vue?vue&type=script&lang=js&"
export * from "./AK6Icon.vue?vue&type=script&lang=js&"
import style0 from "./AK6Icon.vue?vue&type=style&index=0&id=4fc4c1fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc4c1fa",
  null
  
)

export default component.exports